import React from 'react';
import { NavLink } from 'react-router-dom';
import logo from '../../assets/logo.png';

const navItems = [
  { to: '/', label: 'Inicio' },
  { to: '/productos', label: 'Productos' },
  { to: '/sobre-nosotros', label: 'Sobre nosotros' },
  { to: '/contacto', label: 'Contacto' },
];

const PublicHeader = ({ onOpenQuote }) => {
  return (
    <header className="public-header">
      <NavLink to="/" className="public-header-logo" aria-label="Ir a inicio">
        <img src={logo} alt="Maderas del Atlantico" />
      </NavLink>

      <nav className="public-header-nav" aria-label="Navegacion principal">
        {navItems.map((item) => (
          <NavLink
            key={item.to}
            to={item.to}
            className={({ isActive }) =>
              `public-header-link${isActive ? ' active' : ''}`
            }
          >
            {item.label}
          </NavLink>
        ))}
      </nav>

      <button type="button" className="public-quote-button" onClick={onOpenQuote}>
        Cotizacion
      </button>
    </header>
  );
};

export default PublicHeader;
